import React from 'react';
import {
    withStyles,
    Grid,
    ButtonBase,
    Typography,
} from '@material-ui/core';
import MBack from '../view/MBack';
import MSnackbar from '../view/MSnackbar';
import AppUtils from '../../control/apputlis';
import ChatAddItem from './ChatAddItem';
import ChatAddedItem from './ChatAddedItem';
import MNoLiving from '../view/MNoLiving';
import IMApp from '../../net/IMApp';


class ChatAddFriend extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            newData: [],
            oldData: [],
        };
    } 

    componentDidMount() {
        AppUtils.YMPush('MAIN', 'ChatGroup');
        let list = IMApp.getFriendList();
        console.log("getFriendList", list);
        this.setState({ oldData: list });

        this.getApplyFriendList();
    }

    getApplyFriendList = async () => {
        let list = await IMApp.getApplyFriendList();
        console.log('getApplyFriendList', list); 
        const { oldData} =this.state;
        let data = [];
        for (let i = 0; i < list.length; i++) {
            let exist = false;

            for (let j = 0; j < oldData.length; j++) {
                if(list[i].uid == oldData[j].uid){
                    exist = true;
                } 
            }

            if(!exist){
                data.push(list[i]);
            } 
        }

        this.setState({ newData: data })
    }

    componentWillUnmount() {
        this.setState = () => false;
    }

    _onSearchClick = () => {

    }

    renderHandle = (newData) => {
        const { classes } = this.props;
        return (
            <Grid container direction='row' alignItems='center'>
                <Grid container direction='row' alignItems='center' className={classes.headerView}>
                    <Typography style={{ fontSize: 12, color: '#878787' }}>待处理</Typography>
                </Grid>
                <Grid container direction='column' alignItems='center'>
                    {
                        newData.map((item, i) => (
                            <ChatAddItem key={i} data={item} />
                        ))
                    }
                </Grid>
            </Grid>
        );
    }

    renderAdded = (oldData) => {
        const { classes } = this.props;
        return (
            <Grid container direction='row' alignItems='center'>
                <Grid container direction='row' alignItems='center' className={classes.headerView}>
                    <Typography style={{ fontSize: 12, color: '#878787' }}>近期请求</Typography>
                </Grid>
                <Grid container direction='column' alignItems='center'>
                    {
                        oldData.map((item, i) => (
                            <ChatAddedItem key={i} data={item} end={i == (oldData.length - 1)} />
                        ))
                    }
                </Grid>
            </Grid>
        );
    }

    renderEmpty = () => {
        return (
            <Grid style={{ marginTop: 64 }}>
                <MNoLiving title='暂无好友请求' />
            </Grid>
        );
    }

    render() {
        const { newData, oldData } = this.state;
        return (
            <MBack title='新的好友'>
                <Grid style={{ height: 8 }}></Grid>
                {newData.length > 0 && this.renderHandle(newData)}
                {oldData.length > 0 && this.renderAdded(oldData)}
                {(newData.length == 0 && oldData.length == 0) && this.renderEmpty()}
                <MSnackbar ref={(ref) => { this.toast = ref }} />
            </MBack >
        );
    }
}
export default withStyles((theme) => ({
    container: {
        width: '100vw',
        padding: theme.spacing(0, 1.5, 0, 1.5),
    },
    headerView: {
        height: 32,
        backgroundColor: '#E7E7E7',
        width: '100vw',
        paddingLeft: 8
    },
    searchInput: {
        flex: 1,
        width: '100%',
        height: '100%',
        margin: theme.spacing(0, 0, 0, 1),
        backgroundColor: 'transparent',
        justifyContent: 'center',
        border: 'none',
        outline: 'none',
        color: '#3A445F',
        fontSize: theme.typography.pxToRem(11),
    },
    searchButton: {
        width: '100%',
        height: 32,
        backgroundColor: '#2E2E2E',
        borderRadius: 8,
        width: 'calc(100vw - 24px)',
    }

}))(ChatAddFriend);
